
<portal to="modal">
  <div
    ref="background"
    class="background"
    v-if="!isInPrintMode"
    :aria-hidden="suppressed ? 'true' : undefined"
    :class="{
      'center-vertically': centerVertically,
      'cover-snackbars': coverSnackbars,
      'fade-away': fadeAway,
      'fade-in': fadeIn,
      suppressed: suppressed
    }"
    @click.self="$emit('outsideClick')"
  >
    <slot></slot>
  </div>
</portal>
